import React, { useState } from 'react';
import { Grid, Paper, Box, Button, TextField, Switch } from '@material-ui/core';
import { CloudUpload as CloudUploadIcon } from '@material-ui/icons';

import { useSnackbar } from 'hooks';
import api from 'services/api';
import useStyles from './styles';
import schema from './restaurantSchema';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { ScheduleSettings } from './ScheduleSettings';

function RestaurantSettings({ restaurant, setRestaurant, getRestaurants }) {
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [isShowcase, setIsShowcase] = useState(restaurant.showcase);
  const [schedule, setSchedule] = useState(JSON.parse(restaurant.schedule));

  const { openSnackbar } = useSnackbar();
  const classes = useStyles();

  const { register, handleSubmit, errors, control } = useForm({
    validationSchema: schema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(schema),
  });

  const upload = async (e) => {
    setLoadingUpload(true);
    try {
      const formData = new FormData();
      const file = e.target.files[0];
      formData.append('file', file);

      const { data } = await api.post(
        `/restaurants/${restaurant.id}/logo`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        },
      );

      openSnackbar('Logo atualizada com sucesso.');

      setRestaurant({ ...restaurant, logo: data.object.logo });

      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      openSnackbar(
        'Ocorreu um erro ao atualizar a logo, tente novamente em alguns instantes.',
        'error',
      );
    }
    setLoadingUpload(false);
  };

  const onSubmit = async ({ name, description }) => {
    try {
      await api.put(`/restaurants/${restaurant.id}`, {
        name,
        description,
        schedule: JSON.stringify(schedule),
        showcase: isShowcase,
      });

      openSnackbar('Restaurante atualizado com sucesso.');
      getRestaurants();
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      openSnackbar(
        'Ocorreu um erro ao atualizar o restaurante, tente novamente em alguns instantes.',
        'error',
      );
    }
  };

  const handleChangeIsShowcase = (_ev, value) => {
    setIsShowcase(value);
  };

  const handleUpdateSchedule = (updatedSchedule) => {
    setSchedule(updatedSchedule);
  };

  return (
    <Box mt={3}>
      <Grid container spacing={2}>
        <Grid item md={5} xs={12}>
          <Box component={Paper} p={3}>
            {restaurant.logo && (
              <Box display="flex" justifyContent="center" mb={2}>
                <img
                  src={restaurant.logo}
                  className={classes.image}
                  alt="logo restaurante"
                />
              </Box>
            )}
            <Button
              variant="contained"
              component="label"
              disabled={loadingUpload}
              fullWidth
              startIcon={<CloudUploadIcon />}
            >
              {loadingUpload ? 'Enviando' : 'Upload logo'}
              <input
                type="file"
                accept="image/png, image/jpeg"
                hidden
                onChange={upload}
              />
            </Button>
          </Box>
        </Grid>
        <Grid item md={7} xs={12}>
          <Box component={Paper} p={3}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="name"
                as={
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Nome"
                    inputRef={register}
                    fullWidth
                    error={!!errors.name}
                    helperText={errors.name && errors.name.message}
                  />
                }
                defaultValue={restaurant.name || ''}
                control={control}
              />
              <Controller
                name="description"
                as={
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Descrição"
                    inputRef={register}
                    fullWidth
                    multiline
                    rows={3}
                    error={!!errors.description}
                    helperText={
                      errors.description && errors.description.message
                    }
                  />
                }
                defaultValue={restaurant.description || ''}
                control={control}
              />

              <Switch
                onChange={handleChangeIsShowcase}
                defaultChecked={isShowcase}
              />
              <label>Vitrine</label>

              <ScheduleSettings
                schedule={restaurant.schedule}
                onUpdate={handleUpdateSchedule}
              />

              <Box mt={3} display="flex" justifyContent="flex-end">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                  className={classes.submitButton}
                >
                  Salvar
                </Button>
              </Box>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default RestaurantSettings;
